const All = (): JSX.Element => (
  <svg
    width="23px"
    height="23px"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.88 6.09a1.02 1.02 0 1 0 0-2.04 1.02 1.02 0 0 0 0 2.04ZM9.96 5.07a1.02 1.02 0 1 1-2.04 0 1.02 1.02 0 0 1 2.04 0ZM12 6.09a1.02 1.02 0 1 0 0-2.04 1.02 1.02 0 0 0 0 2.04ZM6.899 11.267a.975.975 0 1 0 0 1.95h9.996a.975.975 0 0 0 0-1.95H6.899ZM5.924 16.108c0-.538.437-.975.975-.975h5.553a.975.975 0 1 1 0 1.95H6.9a.975.975 0 0 1-.975-.975Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.114.29A4.333 4.333 0 0 0 .78 4.623v12.753a4.333 4.333 0 0 0 4.334 4.334h13.773a4.333 4.333 0 0 0 4.333-4.334V4.623A4.333 4.333 0 0 0 18.887.29H5.114Zm13.773 1.95H5.114A2.383 2.383 0 0 0 2.73 4.623v2.612h18.54V4.623a2.383 2.383 0 0 0-2.383-2.383ZM2.73 17.376V8.86h18.54v8.517a2.383 2.383 0 0 1-2.383 2.383H5.114a2.383 2.383 0 0 1-2.384-2.384Z"
      fill="currentColor"
    />
  </svg>
);

export default All;
